<template>
  <a-config-provider
    :theme="{
      token: {
        algorithm: true,
        colorPrimary: 'var(--primary-color)',
        colorPrimaryHover: 'var(--secondary-color)',
        colorBorder: 'var(--white-opacity-8)',
      },
      primaryColor: 'var(--primary-color)',
      components: {
        Message: { algorithm: true },
        Button: {
          algorithm: true,
          colorPrimary: 'var(--primary-color)',
          colorPrimaryHover: 'var(--secondary-color)',
          colorBorder: 'var(--white-opacity-8)',
        },
        Tabs: {
          algorithm: true,
          colorPrimary: 'var(--primary-color)',
        },
        Radio: {
          algorithm: true,
          colorPrimary: 'var(--primary-color)',
        },
        Input: {
          algorithm: true,
          colorPrimary: 'var(--primary-color)',
          colorPrimaryHover: 'var(--secondary-color)',
          colorBorder: 'var(--white-opacity-8)',
        },
        Select: {
          algorithm: true,
          colorPrimary: 'var(--primary-color)',
          colorPrimaryHover: 'var(--secondary-color)',
          colorBorder: 'var(--white-opacity-8)',
        },
        Table: {
          algorithm: true,
          headerColor: '#888888',
          headerBg: 'var(--white-opacity-8)',
          headerSplitColor: 'transparent',
          colorSplit: 'transparent',
          controlItemBgHover: 'transparent',
          headerFilterHoverBg: 'transparent',
          rowHoverBg: 'var(--white-opacity-8)',
          rowSelectedHoverBg: 'transparent',
          rowSelectedBg: 'transparent',
          headerSortHoverBg: 'transparent',
          cellPaddingBlock: 12,
          cellPaddingInline: 16,
          borderRadius: '0.5rem',
        },
        Pagination: {
          algorithm: true,
          itemActiveBg: 'var(--white-opacity-8)',
          itemActiveBgDisabled: 'var(--white-opacity-4)',
          itemActiveColorDisabled: 'var(--white-opacity-40)',
          itemBg: 'transparent',
          itemInputBg: 'transparent',
          itemLinkBg: 'transparent',
          itemSize: 32,
          itemSizeSM: 24,
          colorText: 'var(--foreground-rgb)',
          colorTextDisabled: 'var(--white-opacity-40)',
          colorBgContainer: 'transparent',
          colorBorder: 'var(--white-opacity-12)',
          colorPrimary: 'var(--primary-color)',
          colorPrimaryHover: 'var(--secondary-color)',
          borderRadius: 4,
        },
        Checkbox: {
          algorithm: true,
          colorPrimary: 'var(--primary-color)',
          borderRadiusSM: 2,
        },
      },
      algorithm:
        effectiveTheme === themeTypes.DARK
          ? theme.darkAlgorithm
          : theme.defaultAlgorithm,
    }"
  >
    <body :style="{ backgroundColor: 'var(--background-color)' }">
      <slot></slot>
    </body>
  </a-config-provider>
</template>

<script setup>
import { computed } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { theme } from "ant-design-vue";
import { themeTypes } from "@/src/constants/themeConstants.js";
import { useAuthStore } from "@/src/composables/useAuthStore.js";

const store = useStore();
const route = useRoute();
const authStore = useAuthStore();

const effectiveTheme = computed(() => {
  const isPublicRoute = route.meta.public === true;
  const isAuthenticated = authStore.isAuthenticated.value;

  if (isPublicRoute && !isAuthenticated) {
    return themeTypes.LIGHT;
  }
  return store.getters["theme/getEffectiveTheme"];
});
</script>
